var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: 24,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.334 81H77.667C57.424 81 41 97.424 41 117.667v276.665C41 414.576 57.424 431 77.667 431H431c20.243 0 40-16.424 40-36.668V117.667C471 97.424 454.576 81 434.334 81z",
    fill: "#f9f9f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M432.771 228.354c9.243-1.909 14.284-8.097 14.284-17.722 0-21.771-23.146-18.639-40.408-18.639l-.001 62.639h12.223v-25.055h1.681l16.958 25.055h14.973l-19.71-26.278zm-10.314-7.333h-3.589v-19.02h3.742c7.715 0 11.917 3.207 11.917 9.243 0 6.416-4.202 9.777-12.07 9.777zM363.943 192.07h34.606v10.694h-22.381v13.904h21.616v10.54h-21.616v16.959h22.381v10.541h-34.606zM311.465 192.07l16.729 42.166 16.959-42.166h13.368l-27.118 64.319h-6.569l-26.737-64.319z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M268.764 189.779c18.868 0 34.07 15.277 34.07 34.069 0 18.868-15.279 34.07-34.07 34.07-18.868 0-34.069-15.279-34.069-34.07-.001-18.868 15.279-34.069 34.069-34.069z",
    fill: "#ff6f00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.104 194.438v14.514c-15.353-15.354-35.749-3.589-35.749 14.514 0 19.098 21.006 29.411 35.749 14.667v14.514c-22.687 10.923-48.354-4.354-48.354-29.181 0-23.834 25.285-40.486 48.354-29.028zM156.855 245.083c8.708 0 17.111-11.687-2.521-18.638-11.457-4.202-15.43-8.708-15.43-17.34 0-17.723 23.374-23.986 37.965-10.922l-6.417 8.248c-7.944-8.86-19.021-4.736-19.021 1.912 0 3.36 2.063 5.269 9.396 7.866 13.903 5.042 18.028 9.55 18.028 19.555 0 22.536-29.639 28.571-43.236 8.632l7.869-7.562c2.825 5.423 7.561 8.249 13.367 8.249zM118.66 192.07h12.223v62.638H118.66z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M471 394.332V292.98c-29.646 18.515-201.373 106.348-369.99 138.008h330.455c20.08-.249 39.535-16.567 39.535-36.656z",
    fill: "#ff6f00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.321 192.07H61.445v62.638H79.32c23.604 0 33.687-17.11 33.687-31.242.001-18.41-13.749-31.396-33.686-31.396zm14.283 47.208c-3.743 3.361-8.861 4.889-16.729 4.889h-3.209v-41.403h3.209c7.868 0 12.757 1.299 16.729 5.041 4.354 3.821 6.799 9.625 6.799 15.66.001 6.035-2.445 11.84-6.799 15.813z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.b5230b624516e2bb513de712b288a269.svg";
export { ForwardRef as ReactComponent };